const reducer = state => ({
  ...state,
  loading: true,
  addresses: [],
  error: null,
});

export default reducer;
